/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMainAccountInternal} from '../api'

 export const useQueryGetMainAccountInternal = createReactQueryHook('getMainAccountInternal', getMainAccountInternal)
